import { useMemo, useState, ReactNode } from 'react'
import MarkAuftraegeAsDoneContext from '@repo/ui/contexts/MarkAuftraegeAsDoneContext'
import { useBefehlMarkedAsDoneStore } from '../../../store/useBefehlMarkedAsDoneStore'
import { useShallow } from 'zustand/react/shallow'

interface MarkAuftraegeAsDoneProviderProps {
  children: ReactNode
  initialBefehlId: string
}

export default function MarkAuftraegeAsDoneProvider({
  children,
  initialBefehlId
}: Readonly<MarkAuftraegeAsDoneProviderProps>) {
  const { isDone, setMarkedAsDone } = useBefehlMarkedAsDoneStore(
    useShallow((state) => ({
      isDone: state.isDone,
      setMarkedAsDone: state.setMarkedAsDone
    }))
  )

  const befehlFrontendId = initialBefehlId
  const [isBefehlsnachrichtQuittiert, setIsBefehlsnachrichtQuittiert] =
    useState<boolean>(false)

  const value = useMemo(
    () => ({
      isDone,
      setMarkedAsDone,
      befehlFrontendId,
      isBefehlsnachrichtQuittiert,
      setIsBefehlsnachrichtQuittiert
    }),
    [
      isDone,
      setMarkedAsDone,
      befehlFrontendId,
      isBefehlsnachrichtQuittiert,
      setIsBefehlsnachrichtQuittiert
    ]
  )

  return (
    <MarkAuftraegeAsDoneContext.Provider value={value}>
      {children}
    </MarkAuftraegeAsDoneContext.Provider>
  )
}
